( function ($) {
    var isMobile = window.matchMedia('(max-width: 991px)');

    $(document).ready(function () {
        meetingTableWidth();
        meetingSelectTable();
    });

    $(window).resize(function () {
        meetingTableWidth();
        meetingSelectTable();
    });

    function meetingTableWidth() {
        var tables = $('.section_meeting_table .table');
        tables.each(function () {
            var table = $(this);

            if (table.length > 0 && !is_mobile) {
                var cell = table.find('.table_row_labels .table_label:not(.custom_width):not(.hidden_on_desktop)'),
                    custom_width_cell = table.find('.table_row_labels .table_label.custom_width:not(.hidden_on_desktop)'),
                    num_custom_width_cell = custom_width_cell.length,
                    num_of_cell = cell.length + num_custom_width_cell,
                    cell_width = cell.outerWidth(),
                    first_cell_width = custom_width_cell.outerWidth(),
                    width = cell_width * num_of_cell + first_cell_width * num_of_cell,
                    wrap_width = table.closest('.wrap').width();


                if (width < wrap_width) {
                    width = wrap_width;
                }
                table.find('.table_cell').css({
                    width: cell_width + 'px'
                });
                table.find('.custom_width').css({
                    width: first_cell_width + 'px'
                });
                table.find('.table_row').css({
                    width: width + 'px',
                    //'min-width': '100%'
                })
            }
        });
    }

    function meetingSelectTable() {
        var wraps = $('.section_meeting_table .table');
        wraps.each(function () {
            var wrap = $(this),
                select = wrap.find('.filter_table'),
                hiddenClass = 'hidden_on_mobile';

            if (select.length > 0 && is_mobile) {
                select.change(function () {
                    var $this = $(this),
                        filter = $this.find(':selected').attr('data-filter-value'),
                        cell = wrap.find('.element_to_filter');

                    cell.addClass(hiddenClass);
                    wrap.find(filter).removeClass(hiddenClass);

                })
            }
        })
    }

}(jQuery) );